export default __webpack_public_path__ + "static/media/invoice-template-2.ae1e30d6.png";